import React, {useState} from 'react'
import ServiceContainer from "../containers/ServiceContainer";
import SubmitButtonContainer from "../containers/SubmitButtonContainer";
import EndUserContainer from "../containers/end_user/EndUserContainer";
import { useTranslation } from "react-i18next";
import SignInButton from "../../../../shared/my_account_button/components/SignInButton";
import SaveDraftButton from "../components/SaveDraftButton";
import { Breadcrumb } from "../components/form/Breadcrumb";
import { FormHeading } from "../../shared/components/Typograhy";
import AddService from "../components/summary/AddService";
import {BackButton, ButtonArea, NextButton} from "../../shared/components/Buttons";
import SlideInAnimation from "../../shared/components/SlideInAnimation";
import Cgv from "./summary/Cgv";
import GoodBehaviourAgreement from "../components/summary/GoodBehaviourAgreement";
import Textarea from "../../shared/components/form/Textarea";
import {ChatBubbleLeftRightIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import {Label} from "../../shared/components/form/Layout";
import moment from 'moment'
import {getHasBagTransportService} from "../../../data/booking/selectors/summary";
import CgvReminder from "../components/summary/CgvReminder";

const Summary = ({
    data,
    onChangeComment,
    anonymous,
    isEditing,
    readOnly,
    serviceList, isValid, isUpdateValid, onSubmit,
     isSubmitting,
     isUpdating,
     onBack
}) => {
    const { t } = useTranslation();
    const [cgvApproved, setCgvApproved] = useState(false)
    const [cgvReminder, setCgvReminder] = useState(data.type == 'reservation' && moment().add(3, 'days').isSameOrAfter(moment(data.startAt)))
    const hasBagTransportService = getHasBagTransportService(data.services)
    const [goodBehaviourApproved, setGoodBehaviourApproved] = useState(!hasBagTransportService)

    return (
        <SlideInAnimation>
            <Breadcrumb title="Récapitulatif" />
            <FormHeading title={t("booking.your_demand")} />
            <div className="mt-8 mb-4">
                <EndUserContainer />
                <div className={"space-y-8 lg:space-y-16"}>
                    {data.services.map((service) => (
                        <ServiceContainer
                            key={service.id}
                            service={service}
                            showActions={!readOnly}
                        />
                    ))}
                </div>
                {!readOnly && (
                    <>
                        <AddService serviceList={serviceList} />
                        {!anonymous && isValid === true && (<>
                                <div className="mt-10">
                                    <Label Icon={ChatBubbleLeftRightIcon} htmlFor="comment" className="text-2xl font-medium text-gray-900">
                                        {t("booking.something_to_add")} :
                                    </Label>
                                    <Textarea
                                        readOnly={isEditing}
                                        value={data.comment}
                                        placeholder={t("booking.enter_comment")}
                                        onChange={onChangeComment} 
                                        className={"border-stone-400"} />
                                </div>
                                <div className={"mt-12"}>
                                    {hasBagTransportService && <GoodBehaviourAgreement onChange={setGoodBehaviourApproved} />}
                                    <Cgv onChange={setCgvApproved} className={"mt-4"} />
                                </div>
                            </>
                        )}



                        {!anonymous && isValid !== true && <div className={" mt-12  rounded-md border-orange-200 border-2 p-5"}>
                            <div className="flex items-center mb-5">
                                <ExclamationTriangleIcon className={`text-red-600 mr-1 h-5 w-5`} />
                                <span className="font-medium">{t("booking.not_found_accommodation")}</span>
                            </div>
                            <div>{`${t("booking.modify_luggage_transport")} ${moment(isValid.date).format('DD/MM/YYYY')} ${t("booking.your_booking")}`}</div>
                            <div className="ml-10 mt-3">
                                <ul className="list-disc">
                                    <li>{t("booking.establishment_name")}</li>
                                    <li>{t("booking.contact_email")}</li>
                                </ul>
                            </div>
                            <div className="mt-3">{t("booking.email_is_required_1")} <span className="font-bold">{t("booking.email_is_required_2")}</span> {t("booking.if_staying_unknown_accommodation")}</div>
                        </div>}

                        <ButtonArea className="flex-col space-y-4 lg:flex-row lg:space-y-0">
                            {anonymous ? (
                                <SignInButton
                                    classname="lg:ml-auto"
                                    disabled={isEditing}
                                />
                            ) : (
                                <>
                                {!isUpdating ? <SaveDraftButton disabled={isEditing || isSubmitting || (data.endUser == null && data.clientData == null && data.customer.type !="consumer")} /> :
                                    <BackButton onClick={onBack}>{t("booking.cancel")}</BackButton>}
                                    <NextButton
                                        type="submit"
                                        disabled={!cgvApproved || !goodBehaviourApproved || isUpdateValid !== true || isValid !== true || isSubmitting || (data.endUser == null && data.clientData == null && data.customer.type !="consumer")}
                                        classname="lg:ml-auto"
                                        onClick={onSubmit}
                                        loading={isSubmitting}
                                    >
                                        {t("booking.validate_request")}
                                    </NextButton>
                                </>
                            )}
                        </ButtonArea>
                    </>
                )}
            </div>
            <CgvReminder open={cgvReminder} setOpen={setCgvReminder} />
        </SlideInAnimation>
    );
};
export default Summary;
